import {PersonalInfo} from "./personal-info";
import {SourceOfFunds} from "./source-of-funds";
import {Employment} from "./employment";
import {InvestmentKnowledge} from "./investment-knowledge";
import {SigningDone} from "./signing-done";
import {PaymentSource} from "../onboarding-shared/payment-source";
import {Payment} from "../onboarding-shared/payment";
import {KYC} from "./kyc";
import {IncomeNetWorth} from "./income-net-worth";
import {BDAffiliation} from "./bd-affiliation";
import {OnboardingEnd} from "./onboarding-end";

const mk_index = (index, total) => {
  return { index, total };
};

const TOTAL = 8

const PershingFlowMap = {
  start_kyc: new KYC(mk_index(0, TOTAL)),
  personal_info: new PersonalInfo(mk_index(1, TOTAL)),
  income_net_worth: new IncomeNetWorth(mk_index(2, TOTAL)),
  source_of_funds: new SourceOfFunds(mk_index(3, TOTAL)),
  employment: new Employment(mk_index(4, TOTAL)),
  investment_knowledge: new InvestmentKnowledge(mk_index(5, TOTAL)),
  bd_affiliation: new BDAffiliation(mk_index(6, TOTAL)),
  summary: new OnboardingEnd(mk_index(7, TOTAL)),
  payment_source: new PaymentSource(false),
  payment: new Payment(),
  signing_done: new SigningDone(),
}

const PERSHING_FIRST_ENDPOINT = "start_kyc";

export { PershingFlowMap, PERSHING_FIRST_ENDPOINT };
